import { APM_NAMES } from 'constants/common'
import { ApmProvider } from 'types/common'

type ApplicationDisplayParams = {
  appName: string
  clientId: string | null
}

type ApplicationDisplayData = {
  appName: string
  authorisationTarget: string
}

// TODO: Remove once iDEAL stops reusing OBA UI we start returning this with application data.
// https://revolut.atlassian.net/browse/PBFAI-1367
const IDEAL_CLIENT_IDS = [
  '5f2d5df7-dd4f-4429-b679-bb9089f20497', // Dev
  '6afe21ab-80d3-478a-a4e4-60870b2e891f', // Prod
]
const IDEAL_APP_NAME = APM_NAMES[ApmProvider.IDEAL]
const IDEAL_AUTHORISATION_TARGET = `the ${IDEAL_APP_NAME} payment`

const isIdealApplication = (clientId: string | null) =>
  clientId !== null && IDEAL_CLIENT_IDS.includes(clientId)

export const getApplicationDisplayData = ({
  appName,
  clientId,
}: ApplicationDisplayParams): ApplicationDisplayData => {
  if (isIdealApplication(clientId)) {
    return {
      appName: IDEAL_APP_NAME,
      authorisationTarget: IDEAL_AUTHORISATION_TARGET,
    }
  }

  return {
    appName,
    authorisationTarget: appName,
  }
}
